export const fmtEur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

export const fmtEur2 = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);

export const fmtPct = (n) => `${(n || 0).toFixed(1)}%`;

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
};

export const MESI = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];

export const EVENT_TYPES = [
  { value: "matrimonio", label: "Matrimonio" },
  { value: "aziendale", label: "Aziendale" },
  { value: "privato", label: "Privato" },
  { value: "concerto", label: "Concerto" },
  { value: "altro", label: "Altro" },
];

export const EVENT_STATUS = [
  { value: "preventivo", label: "Preventivo" },
  { value: "confermato", label: "Confermato" },
  { value: "completato", label: "Completato" },
  { value: "annullato", label: "Annullato" },
];

export const COST_CATEGORIES = [
  { value: "tecnici", label: "Tecnici / Personale" },
  { value: "furgone", label: "Furgone / Trasporto" },
  { value: "consumabili", label: "Consumabili" },
  { value: "ammortamento", label: "Ammortamento attrezzatura" },
  { value: "altro", label: "Altro" },
];

export const EXPENSE_CATEGORIES = [
  { value: "affitto", label: "Affitto" },
  { value: "luce", label: "Bolletta Luce" },
  { value: "gas", label: "Bolletta Gas" },
  { value: "acqua", label: "Bolletta Acqua" },
  { value: "assicurazione", label: "Assicurazione" },
  { value: "carburante", label: "Carburante" },
  { value: "consumabili", label: "Consumabili / Materiale" },
  { value: "marketing", label: "Marketing" },
  { value: "tasse", label: "Tasse / Imposte" },
  { value: "stipendi", label: "Stipendi" },
  { value: "altro", label: "Altro" },
];

export const STAFF_ROLES = [
  { value: "fonico", label: "Fonico" },
  { value: "tecnico", label: "Tecnico" },
  { value: "aiutante", label: "Aiutante" },
  { value: "dj", label: "DJ" },
  { value: "autista", label: "Autista" },
  { value: "altro", label: "Altro" },
];

export const INV_CATEGORIES = [
  { value: "audio", label: "Audio" },
  { value: "luci", label: "Luci" },
  { value: "video", label: "Video" },
  { value: "strutture", label: "Strutture" },
  { value: "cavi", label: "Cavi" },
  { value: "altro", label: "Altro" },
];

export const VAT_RATES = [
  { value: 0, label: "Esente 0%" },
  { value: 4, label: "4%" },
  { value: 10, label: "10%" },
  { value: 22, label: "22%" },
];

export const vatOf = (net, rate) => (Number(net || 0) * Number(rate || 0)) / 100;
export const vatIncl = (gross, rate) => { const r = Number(rate || 0); return r ? (Number(gross || 0) * r) / (100 + r) : 0; };
export const grossOf = (net, rate) => Number(net || 0) + vatOf(net, rate);

export const labelOf = (list, value) => (list.find((x) => x.value === value) || {}).label || value;

export const CASSE = [
  { value: "conto", label: "Conto corrente (fatturato)" },
  { value: "cassa_srl", label: "Cassa contanti SRL (fatturato)" },
  { value: "nero", label: "Contanti (non contab.)" },
];
export const cassaOf = (d) => {
  const c = d && d.cassa;
  if (c === "conto" || c === "cassa_srl" || c === "nero") return c;
  if (d && d.pagamento_contanti) return "nero";
  return d && d.tipo === "contanti" ? "nero" : "conto";
};
export const cassaLabel = (v) => (CASSE.find((c) => c.value === v) || {}).label || "Conto corrente";

export const sessionHours = (t) => {
  if (!t || !t.clock_in || !t.clock_out) return null;
  const h = (new Date(t.clock_out) - new Date(t.clock_in)) / 3600000 - (t.pausa_min || 0) / 60;
  return h > 0 ? h : 0;
};
export const fmtHours = (h) => {
  if (h == null) return "—";
  const tot = Math.round(h * 60);
  return `${Math.floor(tot / 60)}h ${String(tot % 60).padStart(2, "0")}m`;
};
